export const aboutData = {
  title: "Who am I?",
  description1: "My name is Venkatesulu, it also goes by Venkat.",
  description2:
    "I am an emerging full-stack web developer with one year of experience in building attractive websites. Shaped and molded by Masai's immersive curriculum, I specialized in the MERN stack and I am now willing to work on and learn from meaningful projects.",
  image: 1,
};
